import React from 'react'

export const Desc: React.FC = () => {
  return (
    <ul className='mx-4 py-2 pr-4 border-1 border-slate-200 border-solid'>
      <li>
        <b>For the data column:</b>
        <ul>
          <li>
            <b>Mean</b> means the average value.
          </li>
          <li>
            <b>Std</b> means the standard deviation.
          </li>
        </ul>
      </li>
      <li>
        If you see some column print the data source 's formula and without any
        data value, it means either the data is “No Data” on grafana, or this
        version does not have this metrics, then needs manual review.
      </li>
    </ul>
  )
}
